import { FormikProps, useFormik } from 'formik';
import moment from 'moment-timezone';
import { INITIAL_PHONE_NUMBERS } from 'shared/constants/INITIAL_PHONE_NUMBERS';
import { RepresentationType } from 'shared/enums/RepresentationType';
import { ITalentUpdatePayload } from 'shared/interfaces/ITalent';
import { ls } from 'shared/utils/ls';
import * as yup from 'yup';

type FormProps = {
  onSubmit: (values: ITalentUpdatePayload) => void;
};
export const useAdultForm = ({ onSubmit }: FormProps) => {
  const { getLS } = ls();
  const agencyLS = getLS('agency')
    ? JSON.parse(getLS('agency'))
    : {
        stageFirstName: '',
        stageLastName: '',
      };
  const { stageFirstName, stageLastName } = agencyLS;
  const country = moment.tz.guess();
  const isAu = country.includes('Australia');

  const initialValues: ITalentUpdatePayload = {
    contact_no: '',
    country: isAu ? 'Australia' : 'United States',
    country_code: isAu ? 'au' : 'us',
    representation: RepresentationType.FREELANCE,
    stage_first_name: stageFirstName || '',
    stage_middle_name: '',
    stage_last_name: stageLastName || '',
    first_name: stageFirstName || '',
    middle_name: '',
    last_name: stageLastName || '',
    gender: '',
    identifies_as: '',
    sag_status: 'NON UNION',
    sag_id: '',
    union: [],
    other_phone_numbers: INITIAL_PHONE_NUMBERS,
    completed_primary_details: true,
    birth_date: undefined,
    preferences: {
      notification: {
        sms: false,
      },
    },
  };

  const validationscheme = yup.object({
    contact_no: yup.string().min(10, 'Contact number is not valid'),
    representation: yup.string(),
    stage_first_name: yup.string().required('Stage first name is required'),
    stage_middle_name: yup.string().notRequired(),
    stage_last_name: yup.string(),
    first_name: yup.string().required('First name is required'),
    last_name: yup.string().required('Last name is required'),
    country: yup.string().required(),
    country_code: yup.string().required(),
    middle_name: yup.string().notRequired(),
    gender: yup.string().required('Gender is required'),
    identifies_as: yup.string().notRequired(),
    sag_status: yup.string().notRequired(),
    sag_id: yup.string().notRequired(),
    unions: yup.array().notRequired(),
    statistics: yup.object().notRequired(),
    other_phone_numbers: yup.array().notRequired(),
    birth_date: yup.string().required('Birth date is required'),
    preferences: yup.object({
      notification: yup.object({
        sms: yup.boolean().notRequired(),
      }),
    }),
  });

  const form: FormikProps<ITalentUpdatePayload> = useFormik({
    initialValues,
    validationSchema: validationscheme,
    validateOnBlur: true,
    onSubmit: (values) => onSubmit(values),
  });

  return {
    form,
  };
};
